import React from 'react';
import { useLoading } from '../hooks/useLoading';

export const LoadingOverlay = () => {
  const { loading, error } = useLoading();

  if (!loading && !error) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-sm w-full mx-4">
        {loading && (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <p className="text-gray-700">Carregando...</p>
          </div>
        )}
        
        {error && (
          <div className="text-center">
            <div className="text-red-500 mb-4">
              <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <p className="text-gray-700 mb-4">Ocorreu um erro:</p>
            <p className="text-red-500 text-sm">{error.message}</p>
          </div>
        )}
      </div>
    </div>
  );
}; 